import app from '../../app';
import { Store } from 'redux';
import { IAppState } from '../../../../../shared/redux';
import { selectIsNewPublishTermsEnabled } from '../../../../../shared/selectors/publishTerms';

// При добавлении новых инжектов, не забудь добавить сервис в конец файла!
export function publishTermsService(store: Store<IAppState>) {
  const isNewPublishTermsEnabled = () => {
    const state = store.getState();

    return selectIsNewPublishTermsEnabled(state);
  };

  return {
    isNewPublishTermsEnabled,
  };
}

app.service('publishTermsService', ['store', publishTermsService]);
